import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var submitQualification = [{
  path: "submit-qualification",
  name: "submit-qualification",
  component: function component() {
    return import("./submit-qualification.vue");
  }
}];